import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createI18n } from 'vue-i18n'
import router from './router/index.js'
import App from './App.vue'
import en from './i18n/locales/en.json'
import './assets/main.css'
import { initAppListeners, setStatusBarDark } from './services/native.js'
import { initPushNotifications } from './services/pushNotifications.js'

const pinia = createPinia()

const i18n = createI18n({
  locale: 'en',
  fallbackLocale: 'en',
  messages: { en },
})

const app = createApp(App)
  .use(pinia)
  .use(router)
  .use(i18n)

// ── Capacitor native init ─────────────────────────────────────────────────────
// Runs after router is ready so push notification routing works
router.isReady().then(async () => {
  await setStatusBarDark()
  await initPushNotifications(router)
  await initAppListeners(() => {
    // Re-fetch notifications when app resumes from background
    import('./stores/auth.js').then(m => m.useAuthStore().fetchMe?.())
  })
})

app.mount('#app')
